const z = require('zod')
const configs = require('../config.json')

const requiredInProd = type => configs.ENVIRONMENT === 'prod' ? type : type.optional()
const optionalInTests = type => configs.ENVIRONMENT !== 'tests' ? type : type.optional()

const featureFlag = z.union([z.literal('enabled'), z.literal('disabled'), z.literal('experimental')])

const parser = z.object({
  S3_BUCKETNAME: optionalInTests(z.string()),
  HERE_APIKEY: z.string(),
  SUBSCRIPTIONS_URL: optionalInTests(z.string()),
  API_URL: optionalInTests(z.string()),
  SENTRY_DSN: requiredInProd(z.string()),
  SENTRY_AUTH_TOKEN: requiredInProd(z.string()),
  GTM_ID: requiredInProd(z.string()),
  HUBSPOT_ID: requiredInProd(z.number()),
  LANDING_PAGE_DOMAIN: z.string(),
  EDIT_ORDERS_FEATURE_FLAG: featureFlag,
  MIXPANEL_TOKEN: z.string().optional(),
  CARRIER_GROUPS_FEATURE_FLAG: featureFlag,
  UNARCHIVE_ORDERS: featureFlag,
  CHANGE_CONTACT_PERSON: featureFlag,
  ORDER_IMPROVEMENT_PROCESS: featureFlag,
  MY_ADDRESSES_FEATURE_FLAG: featureFlag,
  FUSING_ORDERS_FEATURE_FLAG: featureFlag,
  MIXPANEL_SESSION_RECORDING_PERCENTAGE: z.number().optional(),
  RECAPTCHA_SITE_KEY: requiredInProd(z.string()),
})

const parsedConfigs = parser.parse(configs)

module.exports = { configs: parsedConfigs }
